export default __webpack_public_path__ + "b675daf22b07cb56cd008c1e45e7893c.png";